export enum CONFIG_IS_ENABLED_ENUM {
  ENABLED = '1',
  DISABLED = '0',
}
export const CONFIG_IS_ENABLED_LIST = [
  { value: CONFIG_IS_ENABLED_ENUM.ENABLED, label: '启用' },
  { value: CONFIG_IS_ENABLED_ENUM.DISABLED, label: '停用' },
];

export enum IS_DELETE_ENUM {
  YES = '1',
  NO = '0',
}
export const IS_DELETE_LIST = [
  { value: IS_DELETE_ENUM.YES, label: '是' },
  { value: IS_DELETE_ENUM.NO, label: '否' },
];

export enum CONFIG_TYPE_ENUM {
  PRODUCER = '1',
  CONSUMER = '2',
  BOTH = '3',
}
export const CONFIG_TYPE_LIST = [
  { value: CONFIG_TYPE_ENUM.PRODUCER, label: '生产者' },
  { value: CONFIG_TYPE_ENUM.CONSUMER, label: '消费者' },
  { value: CONFIG_TYPE_ENUM.BOTH, label: '生产者和消费者' },
];

export enum HANDLE_TYPE_ENUM {
  SEND = '1',
  CONSUME = '2',
  BOTH = '3',
}
export const HANDLE_TYPE_LIST = [
  { value: HANDLE_TYPE_ENUM.SEND, label: '发送' },
  { value: HANDLE_TYPE_ENUM.CONSUME, label: '消费' },
  { value: HANDLE_TYPE_ENUM.BOTH, label: '发送和消费' },
];

export const IS_LOCK_LIST = [
  { value: true, label: 'TRUE' },
  { value: false, label: 'FALSE' },
];

export enum BOUND_TYPE_ENUM {
  MQ_PROVIDER = 'MQ_PROVIDER',
  MQ_CONSUMER = 'MQ_CONSUMER',
  EXISTED_SERVICE = 'EXISTED_SERVICE',
  CRON_JOBS = 'CRON_JOBS',
}
export const BOUND_TYPE_LIST = [
  { value: BOUND_TYPE_ENUM.MQ_PROVIDER, label: 'MQ生产者' },
  { value: BOUND_TYPE_ENUM.MQ_CONSUMER, label: 'MQ消费者' },
  { value: BOUND_TYPE_ENUM.EXISTED_SERVICE, label: '已有服务' },
  { value: BOUND_TYPE_ENUM.CRON_JOBS, label: '定时任务' },
];

export enum EXCHANGE_TYPE_ENUM {
  direct='direct',
  topic='topic',
  fanout='fanout',
}
// 交换机类型下拉选项
export const EXCHANGE_TYPE_ENUM_LIST = [
  {
    label: EXCHANGE_TYPE_ENUM.direct,
    value: EXCHANGE_TYPE_ENUM.direct,
  },
  {
    label: EXCHANGE_TYPE_ENUM.topic,
    value: EXCHANGE_TYPE_ENUM.topic,
  },
  {
    label: EXCHANGE_TYPE_ENUM.fanout,
    value: EXCHANGE_TYPE_ENUM.fanout,
  },
];
